// extracted by mini-css-extract-plugin
export default {"root":"how-to-complain-module--root--25190","accordionWrapper":"how-to-complain-module--accordion-wrapper--282d6"};